import { FC } from "react";
import { RentalType } from "../../types";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";

interface Props {
  rental: RentalType;
}

const RentalHistoryCard: FC<Props> = ({ rental }) => {
  return (
    <div className="flex justify-between items-center">
      <div className="flex items-center gap-2 md:gap-5">
        <img
          src={ipfsGatewayImage(
            rental.car.carImages.find((car) => car.imageUrl !== "")
              ?.imageUrl as string
          )}
          alt="vehicle"
          className="w-[40px] h-[40px] md:w-[60px] md:h-[60px] lg:w-[100px] rounded-[10px] object-cover"
        />
        <div className="flex flex-col">
          <p className="text-[#3D475C] font-Inter text-[13px] font-medium leading-4">
            {rental.car.make}
          </p>
          <p className="text-[#9499A1] font-Inter text-[10px] font-normal leading-4">
            {rental.car.model} {rental.car.year}
          </p>
        </div>
      </div>
      <div className="flex flex-col gap-1 md:flex-row-reverse items-center md:gap-10">
        <p
          className={` font-Inter text-[9px] font-normal text-center py-[6px] w-20 rounded-md ${
            rental.rentalStatus === "Active"
              ? "text-[#11B981 bg-[#CFF1E6]"
              : rental.rentalStatus === "Booked"
              ? "text-[#F59E0B] bg-[#FFF7E5]"
              : rental.rentalStatus === "Rejected"
              ? "text-[#EB5757] bg-[#F9D2DA]"
              : "text-[#3D475C] bg-[#F6F7F9]"
          }`}
        >
          {rental.rentalStatus}
        </p>
        <div className="flex gap-1 md:gap-10 lg:gap-16 items-center">
          <div className="flex flex-col gap-3 items-center">
            <p className=" font-Inter font-normal text-[12px] leading-4 hidden text-[#9499A1] md:flex uppercase">
              Start
            </p>
            <p className=" font-Inter font-medium text-[8px] md:text-[12px] leading-4 text-[#3d475c]">
              {new Date(rental.rentalStartDatetime).toLocaleDateString()}
            </p>
          </div>
          <p className="flex md:hidden font-Inter font-normal text-[12px] leading-4">
            -
          </p>

          <div className="flex flex-col gap-3 items-center">
            <p className=" font-Inter font-normal text-[12px] leading-4 hidden text-[#9499A1] md:flex uppercase">
              End
            </p>
            <p className=" font-Inter font-medium text-[8px] md:text-[12px] leading-4 text-[#3d475c]">
              {new Date(rental.rentalEndDatetime).toLocaleDateString()}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RentalHistoryCard;
